export default "__VITE_ASSET__wP5CYDsN__ 584w";